import { CSSProperties, forwardRef, InputHTMLAttributes, ReactNode } from 'react';

// TODO: Refactor to resolve circular dependency
// oxlint-disable-next-line import/no-cycle
import * as S from './style';

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  wrapperStyle?: CSSProperties;
  labelStyle?: CSSProperties;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ id, label, checked, wrapperStyle, labelStyle, disabled, ...props }, ref) => {
    return (
      <S.Wrapper style={wrapperStyle}>
        <S.Input id={id} ref={ref} type="checkbox" checked={checked} {...props} />
        <S.Label htmlFor={id} label={label} style={labelStyle} disabled={disabled}>
          {label}
        </S.Label>
      </S.Wrapper>
    );
  },
);

export default Checkbox;
